import { ReactNode } from 'react';
import classNames from 'classnames';
import { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import IconButton, {
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import { Value } from '@lib/interfaces/form';
import DragDrop from '@lib/assets/icons/dragDrop.svg?react';
import styles from './CustomizeTabsModalForm.module.scss';

interface FieldArrayItemWrapperComponentProps {
  children: ReactNode;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
  isDraggable?: boolean;
  isSubItemDisabled?: boolean;
  isSubItemDraggable?: boolean;
  isSubItemRemovable?: boolean;
  onRemove: () => void;
  parentValue?: Value[];
}

export default function FieldArrayItemWrapperComponent({
  children,
  onRemove,
  isDraggable,
  dragHandleProps,
  parentValue,
  isSubItemDisabled,
  isSubItemDraggable,
  isSubItemRemovable,
}: FieldArrayItemWrapperComponentProps) {
  // Use computed props from form system
  const isItemDraggable =
    isDraggable && isSubItemDraggable && !isSubItemDisabled;
  const isDeleteBtnVisible =
    (parentValue?.length ?? 0) > 1 && isSubItemRemovable && !isSubItemDisabled;

  return (
    <div
      className={classNames(styles.optionWrap, {
        [styles.optionWrapWithDelete]: isDeleteBtnVisible,
        [styles.optionWrapWithDrag]: isItemDraggable,
      })}
    >
      {isItemDraggable && (
        <div className={styles.dragHandle} {...dragHandleProps}>
          <DragDrop />
        </div>
      )}
      {children}
      {isDeleteBtnVisible && (
        <IconButton
          icon="delete"
          type={IconButtonTypes.PrimaryOutlined}
          onClick={onRemove}
          className={styles.optionDeleteBtn}
          symbolsOutlined
        />
      )}
    </div>
  );
}
